// import {
//   CLEAR_AUTH_DATA,
//   LOAD_AUTH_DATA,
//   SET_AUTH_TOKEN,
//   SET_KEYCLOAK_INSTANCE,
// } from './actionTypes';

// const initialState = {
//   user: null,
//   isAuthenticated: false,
//   keycloak: null,
//   authPolicies: [],
//   authToken: null,
// };

// export default function authReducer(state = initialState, action) {
//   switch (action.type) {
//     case CLEAR_AUTH_DATA:
//       return initialState;
//     case SET_KEYCLOAK_INSTANCE:
//       return { ...state, keycloak: action.instance };
//     case SET_AUTH_TOKEN:
//       return { ...state, authToken: action.token };
//     case LOAD_AUTH_DATA:
//       return { ...state, ...action.payload };
//     default:
//       return state;
//   }
// }

// ################ New code ##################
import {
  CLEAR_AUTH_DATA,
  LOAD_AUTH_DATA,
  SET_AUTH_TOKEN,
  SET_KEYCLOAK_INSTANCE,
  SET_DJANGO_AUTH_DATA,
} from './actionTypes';

const initialState = {
  user: null,
  isAuthenticated: false,
  keycloak: null,
  authPolicies: [],
  authToken: null,
  djangoAccessToken: null,
  djangoRoles: null,
  djangoUserInfo: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_AUTH_DATA:
      return initialState;
    case SET_KEYCLOAK_INSTANCE:
      return { ...state, keycloak: action.instance };
    case SET_AUTH_TOKEN:
      return { ...state, authToken: action.token };
    case LOAD_AUTH_DATA:
      return { ...state, ...action.payload };
    case SET_DJANGO_AUTH_DATA:
      return {
        ...state,
        djangoAccessToken: action.payload.access,
        djangoRoles: action.payload.roles,
        djangoUserInfo: action.payload.userInfo,
      };
    default:
      return state;
  }
}
